// this file contains shared tracking logic for all routes by deriving common attributes from api data types
// which are used across all routes and defined globally common attributes like source, partner id etc.

import { getClientId } from '@ixigo/pwa';
import { createTracker } from '@/lib/analytics/create-tracker';
import { getCookieHelpers } from './cookie';
import { getUserInfo } from './user-info';
// import your domain-specific types here as needed
// import type { YourType } from '@/api/types';
// import type { YourDomainType } from '@ixigo/core/your-module';

/**
 * all routes should inherit attributes from this tracker.
 * register common app-specific attributes here
 */
export const globalTracker = createTracker({
	trackMap: {},
});

export function getCommonAttributes() {
	const urlSearchParams = new URLSearchParams(window.location.search);
	const source = urlSearchParams.get('source');
	const commonAttributes: Record<string, string> = {};
	const userInfo = getUserInfo();
	const uid = userInfo?.uid ?? '';
	const clientId = getClientId();
	const cookies = getCookieHelpers();
	const appVersion = cookies.getCookie('appVersion');
	const deviceId = cookies.getCookie('ixiUID');
	if (source) {
		commonAttributes.Source = source;
	}
	// Keys dictated by analytics contract
	commonAttributes['User ID'] = uid;
	commonAttributes['App ID'] = clientId || '';
	commonAttributes['Device ID'] = deviceId || '';
	commonAttributes['App Version'] = appVersion || '';
	return commonAttributes;
}

export function initGlobalAppTracker() {
	const defaultAttributes = getCommonAttributes();
	globalTracker.setContext(() => ({
		getCommonAttributes: () => ({
			...defaultAttributes,
			...getCommonAttributes(),
		}),
	}));
}
